import store from "../../config/store";
import { SiafLiteApiStream, SiafLiteApiRepository } from "../../external";

class ContasPagarService {
  constructor() {
    this.urlBase = "financeiro/contas-pagar";
    this.urlBaseEvent = `/event/${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  baixaEmLote(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lista`).post(body);
  }

  cadastrarLista(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/cadastro-lista`
    ).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getResumoHistoricoContasCliente(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/resumo-historico`
    ).patch();
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getResumoTotaisAPagar() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-contas-pagar-totais`
    ).get();
  }

  getResumoContasPagar() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-contas-pagar`
    ).get();
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/resumido`
    ).patch(body);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/detalhado`
    ).path(body);
  }

  cadastrarPagamentos(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/pagamentos`
    ).post(body);
  }

  desdobrarTitulo(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/desdobrar-titulos`
    ).post(body);
  }
}

export default ContasPagarService;
